import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const EVICTION_TERMINATION_SOURCES_B = [
  {
    sourceId: "eviction-source-nonpayment",
    topicId: "eviction-termination",
    title: "Non-payment of rent",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/non-payment-of-rent",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 more-than-14-days arrears, non-payment notice, current 14-day leave period와 catch-up·repayment-plan statement를 확인",
    reviewStatus: "live_verified",
    claimScope: "rent·utility arrears termination notice와 tenant cure options",
    followUp: "rent ledger, actual arrears date, notice wording와 frequent-late-payment exception을 확인",
  },
  {
    sourceId: "eviction-source-guarantee",
    topicId: "eviction-termination",
    title: "Guarantee of tenancy continuing",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/guarantee-of-tenancy-continuing",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 arrears catch-up 또는 agreed repayment plan compliance 시 general guarantee와 frequently-late exception을 확인",
    reviewStatus: "live_verified",
    claimScope: "rent·utility arrears cured after notice·NCAT order의 tenancy continuation protection",
    followUp: "payment clearance, plan compliance, repeated-late allegation과 warrant enforcement status를 즉시 확인",
  },
  {
    sourceId: "eviction-source-process",
    topicId: "eviction-termination",
    title: "Eviction of a tenant from a rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/eviction-of-a-tenant-from-a-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 NCAT termination·possession order, Sheriff-only warrant enforcement, illegal lockout와 retaliatory-eviction application windows를 확인",
    reviewStatus: "live_verified",
    claimScope: "lawful NSW eviction sequence, lockout prohibition와 retaliatory notice response",
    followUp: "termination date, NCAT hearing, possession date, warrant와 retaliatory application deadline을 즉시 확인",
  },
  {
    sourceId: "eviction-source-ncat-orders",
    topicId: "eviction-termination",
    title: "Tenancy and social housing orders",
    publisher: "NSW Civil and Administrative Tribunal",
    url: "https://ncat.nsw.gov.au/case-types/housing-and-property/tenancy/tenancy-and-social-housing-orders.html",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NCAT 공식 orders table에서 breach, new specific grounds, frequent late payment, notice compliance, retaliatory notice, termination·possession order와 evidence requirements를 확인",
    reviewStatus: "live_verified",
    claimScope: "NCAT tenancy termination·possession·retaliatory orders와 supporting documents",
    followUp: "hearing notice의 exact Act section, requested order, evidence와 current response directions 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of EVICTION_TERMINATION_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
